import { ParamIds, Places } from 'src/Constants'
import { RegraFormKeys } from '../regra_form.keys'

export class CondicaoFormKeys extends RegraFormKeys {
    get place() {
        return Places.condicaoForm
    }

    get condicaoId() {
        return this._intent.getParameterAsNumber(ParamIds.condicaoFormId)
    }

    set condicaoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.condicaoFormId, value)
    }
}

export default CondicaoFormKeys
